import { render, staticRenderFns } from "./participant-menu-bar.vue?vue&type=template&id=6536187d&scoped=true&"
import script from "./participant-menu-bar.vue?vue&type=script&lang=ts&"
export * from "./participant-menu-bar.vue?vue&type=script&lang=ts&"
import style0 from "./participant-menu-bar.vue?vue&type=style&index=0&id=6536187d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6536187d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
